import React, { useState } from 'react'
import GoogleLogin, { GoogleLogout } from 'react-google-login';
import { useParams, useNavigate, useLocation, Link } from "react-router-dom";
import { RiLogoutBoxRLine } from "react-icons/ri";
import { getSaveUsers } from "../utilities/common"
import { logoutClear } from "../utilities/common"
import LogoutModal from './LogoutModal';
export default function Header(props) {

    const [showLogoutModal, setShowLogoutModal] = useState(false)

    let navigate = useNavigate();

    // let data = JSON.parse(localStorage?.getItem('userData'))
    let data = getSaveUsers()


    const eventLogoutClick = (response) => {
        navigate("/");
        logoutClear()
    }


    const logout = () => {
        setShowLogoutModal(true)
    }

    return (
        <div className="container">

            <div className="d-flex justify-content-between flex-column flex-md-row">
                <div>
                    <Link to="/home" style={{ color: "#121212" }}><h1 style={{ color: "#121212" }}>Mathrubhumi <span className="fw-bold " style={{ color: "#ff2c2c" }}>LiveBlog<span className="l-blink_me">.</span></span></h1></Link>

                </div>
                <div className="d-flex align-items-end">
                    <h6 className="ms-sm-0 m-0">Welcome <span className="fw-bold">{data?.profileObj?.givenName}</span></h6>
                    <GoogleLogout
                        clientId="634701121546-1bh3398il9o0539ahvqkr6lrqna0l1bk.apps.googleusercontent.com"
                        render={renderProps => (
                            <RiLogoutBoxRLine className="l-cursor ms-2" size="25" onClick={renderProps.onClick} disabled={renderProps.disabled} data-bs-toggle="tooltip" data-bs-placement="top" title="Logout"></RiLogoutBoxRLine>
                        )}
                        buttonText="Logout"
                        onLogoutSuccess={logout}
                    >
                    </GoogleLogout>
                </div>

            </div>

            <hr></hr>

            <LogoutModal onLogoutFunction={() => eventLogoutClick()} onCancelFunction={() => setShowLogoutModal(false)} showLogoutModal={showLogoutModal} ></LogoutModal>
        </div>
    )
}
